import React from 'react';

const RightArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        d="M14.1875 8.71875L9.6875 13.2188L9 13.9375L7.5625 12.5L8.28125 11.8125L11.0625 9H2H1V7H2H11.0625L8.28125 4.21875L7.5625 3.5L9 2.09375L9.6875 2.8125L14.1875 7.3125L14.9062 8L14.1875 8.71875Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RightArrow;
